/**
 * Capitalize first letter of a string
 */
export const capitalizeFirst = (str) => {
    if (!str || typeof str !== 'string') return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Handle input change with auto-capitalize first letter
 * Use this for form inputs that should capitalize automatically
 */
export const handleCapitalizedInput = (e, setter, field) => {
    const value = capitalizeFirst(e.target.value);
    if (typeof setter === 'function') {
        if (field) {
            setter(prev => ({ ...prev, [field]: value }));
        } else {
            setter(value);
        }
    }
    return value;
};
